export const Cyan = '#25CDCD';
export const Magenta = '#ff00ff';
export const White = '#ffffff';